namespace RedBullMOBILE360.CustomerCare {
    export interface FraudNumbersExcelFile extends Serenity.ServiceRequest {
        reportedIdentity?: string;
        reporterList?: string[];
        FileName?: string;
    }
}
